import { useContext } from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { LanguageContext } from '../../contexts/language'
import content from '../../portfolio'
import './Contact.css'

const Contact = () => {
  const { language } = useContext(LanguageContext)
  const { contact } = content[language]
  const labels = {
    de: { title: 'Kontakt', button: 'E-Mail schreiben' },
    en: { title: 'Contact', button: 'Email me' }
  }
  
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  })

  const [titleRef, titleInView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  })

  if (!contact.email) return null

  return (
    <motion.section 
      ref={ref}
      className='section contact center' 
      id='contact'
      initial={{ opacity: 0 }}
      animate={inView ? { opacity: 1 } : { opacity: 0 }}
      transition={{ duration: 0.6 }}
    >
      <motion.h2 
        ref={titleRef}
        className='section__title'
        initial={{ opacity: 0, y: -20 }}
        animate={titleInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
        transition={{ duration: 0.5 }}
      >
        {labels[language].title}
      </motion.h2>
      
      <motion.a 
        href={`mailto:${contact.email}`}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <span type='button' className='btn btn--outline'>
          {labels[language].button}
        </span>
      </motion.a>
    </motion.section>
  )
}

export default Contact
